import type { SystemErrorKind } from '@/lib/lark-error-origin';
import type { BlockedPromptReason } from '@/lib/lark-error-origin';

export type LarkErrorEventKind =
  | 'toast'
  | 'drawer_open'
  | 'lark_question'
  | 'user_answer'
  | 'dismiss'
  | 'blocked_prompt'
  | 'off_topic_redirect'
  | 'off_topic_end'
  | 'repair_pr';

export interface LarkErrorEvent {
  at: string;
  kind: LarkErrorEventKind;
  payload: Record<string, unknown>;
}

export interface LarkErrorDiagnosis {
  toastTitle: string;
  toastBody: string;
  httpStatus?: number;
  route: string;
  pageName: string;
  orgId: string | null;
  userId: string | null;
  role: string | null;
  timestamp: string;
  userAgent: string;
  viewport: string;
  recentNavigations: string[];
  requestId?: string;
  buildId?: string;
  kind: SystemErrorKind;
}

export interface LarkErrorRepair {
  githubPrUrl?: string;
  mergeSha?: string;
  filesTouched?: { count: number; names: string[] };
  verifiedLiveBuildId?: string;
}

export interface LarkErrorPacket {
  origin: 'system';
  sessionId: string;
  systemErrorId: string;
  diagnosis: LarkErrorDiagnosis;
  events: LarkErrorEvent[];
  transcript: Array<{
    role: 'lark' | 'user';
    text: string;
    blocked?: boolean;
    blockedReason?: BlockedPromptReason;
    at: string;
  }>;
  repair: LarkErrorRepair;
}

export const LARK_ERROR_QUESTIONS = [
  'What were you trying to do?',
  'Can you keep working?',
  'Anything I missed?',
] as const;
